const invoiceStatus = {
  NEW: 'new',
  REQUESTED: 'requested',
  ERROR: 'error',
  CANCELED: 'canceled',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  ADVANCED: 'advanced',
  DELAYED: 'delayed',
  LATE: 'late',
  DEFAULTED: 'defaulted',
  PAID: 'paid',
  SETTLED: 'settled',
  SETTLEMENT_COMPLETED: 'settlementCompleted',
  PENDING_REVIEW: 'pendingReview',
  PENDING_ADVANCE: 'pendingAdvance',
}

export default invoiceStatus

export const invoiceStatusUnselected = [
  invoiceStatus.NEW,
  invoiceStatus.PENDING_REVIEW,
  invoiceStatus.REQUESTED,
]

export const stateToDistribute = [
  invoiceStatus.ADVANCED,
  invoiceStatus.LATE,
  invoiceStatus.DELAYED,
]

export const checkPaidInvoiceStatus = (state) =>
  checkState(
    [
      invoiceStatus.PAID,
      invoiceStatus.SETTLED,
      invoiceStatus.SETTLEMENT_COMPLETED,
    ],
    state
  )

export const checkAdvancedState = (state) =>
  checkState(
    [
      invoiceStatus.PENDING_ADVANCE,
      invoiceStatus.REQUESTED,
      invoiceStatus.APPROVED,
      invoiceStatus.PENDING_REVIEW,
    ],
    state
  )

const checkState = (arrayStates, state) =>
  arrayStates.some((currentState) => currentState === state)
